export const MAX_VISIBLE_POPUP_COUNT = 3;
